import React, { useState } from 'react'
import verified from '../Assets/svg/verified.svg'
import calender from '../Assets/svg/calendar.svg'
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

function StaticField(props) {
  const [show, setShow] = useState(true);
  function maskValue(value) {
    const visibleLength = 4;
    const maskedPart = value.slice(0, -visibleLength).replace(/\d/g, '*');
    const visiblePart = value.slice(-visibleLength);
    // return '*'.repeat(value.length);
    return value?.slice(0, 3) +
    "*".repeat(
      value?.length - (value?.length > 6 ? 6 : value?.length)
    ) +
    value?.slice(-3)
  }
  return (
    <div className={`static-div ${props.title === "Date of Birth" ? 'calender' : ''}`}>
      <div className="static-left static-content ">
        <div className="tool-tip-title">{props.title}</div>
        {props.value ? 
        <div className="value">{props.mask && show? maskValue(props?.value):props?.value}</div>:
        <div className="value">{props.children}</div>}
        
      </div>
      <div className="static-right static-content" onClick={()=>setShow(prev => !prev)}>
      {props.mask ?  show ? <VisibilityOff /> : <Visibility />   : null}
       
       {(props.showTick || props.title === "Date of Birth")  &&
        <img
          src={props.title === "Date of Birth" ? calender :verified}
          alt="verified"
        />
        } 
      </div>
    </div>
  );
}

export default StaticField
